"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expandCommunityNodes = expandCommunityNodes;
exports.isRdfListNode = isRdfListNode;
exports.linkedProjectNodeFromCommunityNode = linkedProjectNodeFromCommunityNode;
exports.projectUrlFromCommunityNode = projectUrlFromCommunityNode;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
var _rdfList = require("./rdfList");
function isRdfListNode(store, node, doc) {
  if (node?.elements?.length) return true;
  return Boolean(store.any(node, _solidUi.ns.rdf('first'), null, doc || null));
}
function expandCommunityNodes(store, node, doc) {
  return isRdfListNode(store, node, doc) ? (0, _rdfList.expandRdfList)(store, node) : [node];
}
function linkedProjectNodeFromCommunityNode(node, store) {
  if (!node) return null;
  if (node.termType === 'NamedNode') return node;
  if (node.termType === 'Literal') {
    try {
      return (0, _rdflib.sym)(node.value);
    } catch {
      return null;
    }
  }
  if (node.termType !== 'BlankNode') return null;
  const candidatePredicates = [_solidUi.ns.solid('publicId'), _solidUi.ns.schema('url'), _solidUi.ns.foaf('homepage'), _solidUi.ns.rdfs('seeAlso'), _solidUi.ns.schema('sameAs'), _solidUi.ns.schema('mainEntityOfPage')];
  for (const predicate of candidatePredicates) {
    const linked = store.any(node, predicate);
    if (!linked?.value) continue;
    if (linked.termType === 'NamedNode') {
      return linked;
    }
    if (linked.termType === 'Literal') {
      try {
        return (0, _rdflib.sym)(linked.value);
      } catch {
        // Keep trying the next predicate.
      }
    }
  }
  const outgoing = store.statementsMatching(node, null, null, null);
  const firstNamedNode = outgoing.find(statement => statement.object.termType === 'NamedNode');
  if (firstNamedNode?.object?.value) {
    return firstNamedNode.object;
  }
  return null;
}
function projectUrlFromCommunityNode(node, store) {
  const linkedProjectNode = linkedProjectNodeFromCommunityNode(node, store);
  return linkedProjectNode?.value || node.value || '';
}